import APIConnector from './utils/APIConnector';

const Request = APIConnector.instance;
const ENDPOINT = '/supply/account';

class AccountAPI {
  static list = (page = 0, size = 20) => Request.GET(`${ENDPOINT}?page=${page}&size=${size}`);

  static get = id => Request.GET(`${ENDPOINT}/${id}`);

  static update = (id, accountData) => Request.PUT(`${ENDPOINT}`, accountData);

  static create = accountData => Request.POST(ENDPOINT, accountData);

  static delete = id => Request.DELETE(`${ENDPOINT}/${id}`);
}

export default AccountAPI;
